module.exports = __webpack_public_path__ + "82b7e36cb0d7b3dd6fb79a748ebdfcac.pdf";